import {
  fetchGeneral,
  fetchGraphQL
} from '../Connections';

import {
  getFieldListString
} from './util';


export function queryListParkers(variables, fields) {
  const query = `
    query listParkers(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order]
    ) {
      listParkers(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
};


export function queryCreateParker(variables, fields) {
  const query = `mutation createParker(
    $rate_id: String!,
    $subscription_id: String!,
    $parker: ParkerInput!,
    $start_date: Date!,
    $access_system_start_date: Date
  ) {
    createParker(
      rate_id: $rate_id,
      subscription_id: $subscription_id,
      parker: $parker,
      start_date: $start_date,
      access_system_start_date: $access_system_start_date
    ) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryUpdateParker(variables, fields) {
  const query = `mutation updateParker(
    $subscription_id: String!,
    $parker: ParkerInput!,
    $start_date: Date,
    $access_system_start_date: Date
  ) {
    updateParker(
      subscription_id: $subscription_id,
      parker: $parker,
      start_date: $start_date,
      access_system_start_date: $access_system_start_date
    ) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}


export function queryGetParkerReport(queryParams) {
  return fetchGeneral('/parker_report', {
    method: 'POST',
    body: JSON.stringify(queryParams)
  });
}

export function queryReactivateParker(variables, fields) {
  const query = `
    mutation reactivateParker(
      $parker_id: String!,
    ) {
      reactivateParker(
        parker_id: $parker_id,
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryUpdateParkerAccessSystemStatus(variables, fields) {
  const query = `
    mutation updateParkerAccessSystemStatus(
      $parker_id: String!,
      $access_system_status: ParkerAccessSystemStatusEnum!
    ) {
      updateParkerAccessSystemStatus(
        parker_id: $parker_id,
        access_system_status: $access_system_status
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryCreateParkerStatusHistory(variables, fields) {
  const query = `
    mutation createParkerStatusHistory(
      $parker_id: String!,
      $action: ParkerStatusHistoryActionEnum!,
      $start_date: String!,
      $end_date: String,
      $notes: String,
      $timezone: String
    ) {
      createParkerStatusHistory(
          parker_id: $parker_id,
          action: $action,
          start_date: $start_date,
          end_date: $end_date,
          notes: $notes,
          timezone: $timezone
      ) {
        ${getFieldListString(fields)}
      }
    }`;

    return fetchGraphQL({ query, variables });
}

export function queryUpdateParkerStatusHistory(variables, fields) {
  const query = `
    mutation updateParkerStatusHistory(
      $id: String!,
      $parker_id: String!,
      $action: ParkerStatusHistoryActionEnum!,
      $start_date: String!,
      $end_date: String,
      $notes: String,
      $timezone: String
  ) {
      updateParkerStatusHistory(
          id: $id,
          parker_id: $parker_id,
          action: $action,
          start_date: $start_date,
          end_date: $end_date,
          notes: $notes,
          timezone: $timezone
      ) {
        ${getFieldListString(fields)}
      }
  }`;

  return fetchGraphQL({ query, variables });
}

export function queryDeleteParkerStatusHistory(variables, fields) {
  const query = `
    mutation deleteParkerStatusHistory(
      $id: String!
  ) {
      deleteParkerStatusHistory(
          id: $id
      ) {
        ${getFieldListString(fields)}
      }
  }`;

  return fetchGraphQL({ query, variables });
}

export async function querySendBarcodeEmail(variables) {
  const query = `
    mutation sendBarcodeEmail($parkerId: String!, $emailAddress: String!) {
      sendBarcodeEmail(parkerId: $parkerId, emailAddress: $emailAddress)
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function querySetParkerToNeutral(variables) {
  const query = `
    mutation setParkerToNeutral($parkerId: String!) {
      setParkerToNeutral(parkerId: $parkerId) 
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function querySetAllParkersToNeutral(variables) {
  const query = `
    mutation setAllParkersToNeutral($facilityId: String!) {
      setAllParkersToNeutral(facilityId: $facilityId) 
    }
  `;

  return fetchGraphQL({ query, variables });
}